import { ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST } from "../data/generated/original-message-command-effects-manifest";
import { originalMsgSubArgs, originalMsgSubCommandName } from "./originalMsgSubParser";

type CommandEffectRecord = {
  command: string;
  coverageStatus: string;
  controlFlowHandledByMsgSub?: boolean;
};

const COMMAND_EFFECTS = new Map<string, CommandEffectRecord>(
  ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.commandEffectCandidateCoverage.map((record) => [
    record.command,
    record as CommandEffectRecord
  ])
);

export const ORIGINAL_MESSAGE_COMMAND_RUNTIME_CONSUMPTION = {
  manifest: "docs/original-message-command-effects-manifest.json",
  generatedManifestModule: "web/src/data/generated/original-message-command-effects-manifest.ts",
  consumesDecodedMessageCommands: true,
  sourceBackedStatus: ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.status,
  sourceBackedCriteria: {
    basMessageEmittersDecoded: ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.basMessageEmittersDecoded,
    basEmitterCommandsAnchoredToTimerCandidates:
      ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.basEmitterCommandsAnchoredToTimerCandidates,
    eventQueuedCommandsAnchoredToTimerCandidates:
      ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.eventQueuedCommandsAnchoredToTimerCandidates,
    messageCommandVocabularyAnchored:
      ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.messageCommandVocabularyAnchored,
    queuedCommandEffectsDecoded: ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.queuedCommandEffectsDecoded,
    messageTimerHandlerScopedToCandidateVocabulary:
      ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.messageTimerHandlerScopedToCandidateVocabulary,
    frmFullDecodeNotRequiredForMessageCommandGate:
      ORIGINAL_MESSAGE_COMMAND_EFFECTS_MANIFEST.criteria.frmFullDecodeNotRequiredForMessageCommandGate
  }
} as const;

export function originalMessageCommandRuntimeConsumesDecodedMessageCommands(): boolean {
  return ORIGINAL_MESSAGE_COMMAND_RUNTIME_CONSUMPTION.consumesDecodedMessageCommands;
}

export function originalMessageCommandName(token: string): string {
  return originalMsgSubCommandName(token);
}

export function originalMessageCommandArgs(token: string): string[] {
  return originalMsgSubArgs(token);
}

export function originalMessageCommandDispatch(command: string): CommandEffectRecord | undefined {
  return COMMAND_EFFECTS.get(command.toUpperCase());
}

export function originalMessageCommandHasSourceBackedEffect(command: string): boolean {
  const record = originalMessageCommandDispatch(command);
  return (
    record?.coverageStatus === "anchored_to_timer_candidate" ||
    record?.coverageStatus === "msgsub_control_flow_command" ||
    record?.controlFlowHandledByMsgSub === true
  );
}
